
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from 'app/services/user-data.service';
import { Enterprise, Department, ParticipantData, companyStaff, client, customer } from 'app/models/enterprise-model';
import { EntServiceService } from 'app/services/ent-service.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { InitialiseService } from 'app/services/initialise.service';

import * as moment from 'moment';
import { map, find } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Task } from 'app/models/task-model';
import { Project, workItem } from 'app/models/project-model';
import { WriteService } from 'app/services/writes.service';
import { ChatService } from 'app/services/chat.service';
import { RouteService } from 'app/services/route.service';
import { IconsService } from 'app/services/icons.service';
import { TaskService } from 'app/services/task.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var require: any
declare var $: any;

@Component({
  selector: 'app-ent-customers',
  templateUrl: './ent-customers.component.html',
  styleUrls: ['./ent-customers.component.css']
})

export class EntCustomersComponent implements OnInit {
  clients: client[];
  task: Task;
  setClient: client;
  messageTag = '';
  public msgErr = false;
  public newClient = false;
  public createCust = false;
  value = '';
  results: any;
  clipresults: any;
  managers = [];
  public newCusInfo = false;
  cusInfo: customer;
  del_customer: client;
  n = 1;
  searchingValue = '';
  oldMans = [];
  modalRef2: any;

  constructor(private activatedroute: ActivatedRoute, public usd: UserDataService, public es: EntServiceService, public ico: IconsService, public tsk: TaskService,
    private afs: AngularFirestore, public is: InitialiseService, public ws: WriteService, public modalService: NgbModal, public cs: ChatService, public rs: RouteService) {
    this.task = is.getTask();
    this.setClient = this.is.getClient();
    this.cusInfo = this.is.initCustomer();
    this.del_customer = this.is.getClient();
    if (!es?.clients) {
      this.rs.gotoEntList();
    }
  }

  openLgg(template: TemplateRef<any>) {
      this.modalRef2 = this.modalService.open(template, { size: 'lg' })
  }

  ngOnInit(): void {
    this.task = this.is.getTask();
    //  Activate the tooltips
    $('[rel="tooltip"]').tooltip();

    const tagClass = $('.tagsinput').data('color');

    if ($('.tagsinput').length !== 0) {
      $('.tagsinput').tagsinput();
    }

    $('.bootstrap-tagsinput').addClass('' + tagClass + '-badge');

    //  Init Bootstrap Select Picker
    if ($('.selectpicker').length !== 0) {
      $('.selectpicker').selectpicker({
        iconBase: 'nc-icon',
        tickIcon: 'nc-check-2'
      });
    }
  }

  showChamp(man) {
    console.log(man);
  }

  setTeamer(tm) {
    this.setClient = tm;
    this.oldMans = tm.managers;
  }

  searchClients() {
    this.afs.collection<any>('Enterprises').valueChanges().subscribe(customers => {
      customers?.forEach(cmp => cmp.srTag = 'ent');
      this.afs.collection<any>('Users').valueChanges().subscribe(people => {
        people?.forEach(cmp => cmp.srTag = 'ind');
        this.filterSearch(customers.concat(people));
      })
    })
    // this.afs.collection<ParticipantData>('Enterprises').valueChanges().subscribe(customers => {
    //   this.filterSearch(customers);
    // })
  }

  filterSearch(coll: any[]) {
    console.log(this.usd.setCompany.id);
    let word = this.value; const clipresults = [];
    coll.forEach(man => {
      const name = man?.name?.toLowerCase();
      if (word !== '' || ' ') {
        word = word.toLowerCase();
        if (name?.includes(word)) {
          this.clipresults = clipresults;
          this.afs.doc(`Enterprises/${this.usd.setCompany.id}/clients/${man.id}`).ref.get().then
            (pop => {
              if (pop.exists) {
                man.join = true;
                clipresults.push(man);
                console.log('true');
              } else {
                console.log('false');
                man.join = false;
                clipresults.push(man);
              }
            })
        }
      }
      return this.clipresults;
    });
  }

}
